export default "__VITE_ASSET__t7adv2vx__"